import {DEFAULT_LANGUAGE} from "@typesDef/profile.types";

export enum AssignmentStatus {
    pending = "pending", // default
    active = "active", // active assignment
    history = "history" // assignment is history
}

export const ASSIGNMENT_DEFAULT_STATUS = AssignmentStatus.pending;
export const ASSIGNMENT_STATUS: string[] = Object.values(AssignmentStatus);

export const ASSIGNMENT_DEFAULT_CHANNEL_LANGUAGE = DEFAULT_LANGUAGE;

